import React from "react";

// Preserve the original autumn working-state animation, with paper edge shading.
export default function WorkSpinner() {
  return (
    <svg className="work-wheel" width="56" height="56" viewBox="0 0 80 80" aria-hidden="true">
      <path d="M42 12 L47 27 L59 20 L54 34 L70 32 L58 42 L72 51 L56 52 L61 67 L46 59 L42 74 L38 59 L23 67 L28 52 L12 51 L26 42 L14 32 L30 34 L25 20 L37 27 Z" fill="#823819" opacity=".3" />
      <path d="M40 6 L45 21 L57 14 L52 28 L68 26 L56 36 L70 45 L54 46 L59 61 L44 53 L40 68 L36 53 L21 61 L26 46 L10 45 L24 36 L12 26 L28 28 L23 14 L35 21 Z" fill="#ffe0a0" stroke="#fff3d0" strokeWidth="2" strokeLinejoin="round" />
      <path d="M40 22 V62 M40 36 L26 28 M40 36 L54 28 M40 48 L29 42 M40 48 L51 42" stroke="#d88642" strokeWidth="1.8" fill="none" strokeLinecap="round" />
      <path d="M40 62 Q42 70 38 75" stroke="#d88642" strokeWidth="3" fill="none" strokeLinecap="round" />
    </svg>
  );
}
